__turbopack_context__.v({
  "GiftSelect": "GiftSelect-module__6vo9MW__GiftSelect",
  "giftList": "GiftSelect-module__6vo9MW__giftList",
  "info": "GiftSelect-module__6vo9MW__info",
  "item": "GiftSelect-module__6vo9MW__item",
  "name": "GiftSelect-module__6vo9MW__name",
  "text": "GiftSelect-module__6vo9MW__text",
  "title": "GiftSelect-module__6vo9MW__title",
});
